import { ClientJS } from 'clientjs';

import { genericStorage, getCookie } from '@ajaibid/utils';
import { COOKIE_KEY, COOKIE_SECURE } from '@config/constanta';

import Cookies from 'js-cookie';
import { getAccessToken } from './token';

// Create a new ClientJS object
const client = new ClientJS();

// Get the client's fingerprint id
const fingerprint = client.getFingerprint();
const browserInfo = client.getBrowser();
const OSInfo = client.getOS();

function getAcceptLanguage() {
  const lang = genericStorage.get('lang') || 'id';
  return { 'Accept-Language': lang };
}

function getAuthorization() {
  return { Authorization: `jwt ${getAccessToken()}` };
}

function getXHtVerId() {
  const hashedEmail = getCookie(COOKIE_KEY.hashedHeader);
  // Always send a version id so the WAF/version gate never receives a bare
  // request; fall back to the device signature/fingerprint when absent.
  const fallback = Cookies.get(COOKIE_KEY.deviceSign) || fingerprint;
  return { 'X-Ht-Ver-Id': hashedEmail || fallback };
}

function getDeviceSignature() {
  const storedDeviceSignature = Cookies.get(COOKIE_KEY.deviceSign);
  const usedDeviceSign = storedDeviceSignature || fingerprint;

  // Use generated Fingerprint & store in cookie
  Cookies.set(COOKIE_KEY.deviceSign, usedDeviceSign, {
    ...COOKIE_SECURE,
    expires: 300,
  });
  return {
    'X-DEVICE-NAME': `Web ${browserInfo || ''} (${OSInfo || ''})`,
    'X-DEVICE-SIGNATURE': usedDeviceSign,
  };
}

export function defineHeaders() {
  const headers = {
    ...getAcceptLanguage(),
    ...getAuthorization(),
    'Content-Type': 'application/json',
    'X-Platform': 'WEB',
    'X-Product': 'stock-mf',
    ...getDeviceSignature(),
    ...getXHtVerId(),
  };

  return headers;
}
